<template>
    <KvTable :items="items"/>
</template>
<script>
import KvTable from '@/components/Table/kvTable';
import {_PROGRESS_TIME_RANGE, _START_TIME_RANGE} from "../../../../Table/static";

export default {
  components: {KvTable},
  props: ['eventProps'],
  data() {
    const item = [
      {
        index: 0,
        keyTitle: this.$t('status.date'),
        keyType: 'DefaultInfoInput',
        class: '',
        keyRange: [],
        values: this.moment(this.eventProps.date).locale(this.$t('country')).format('ll')
      },
      {
        index: 1,
        keyTitle: this.$t('rehabilitation.start_time'),
        keyType: 'DefaultInfoInput',
        class: '',
        keyRange: _START_TIME_RANGE,
        values: _START_TIME_RANGE.filter(startTimeRange => {
          return startTimeRange.value === this.eventProps.startTime
        })[0]?.title,
        value: _START_TIME_RANGE.filter(startTimeRange => {
          return startTimeRange.value === this.eventProps.startTime
        })[0]?.value
        // TODO : values 는 labels 의 역할, value 가 value, 이 테이블 공통화를 만들 당시 이 부분을 고려 못한듯함.
      },
      {
        index: 2,
        keyTitle: this.$t('RMC.schedule_progress_time'),
        keyType: 'DefaultInfoInput',
        class: '',
        keyRange: _PROGRESS_TIME_RANGE,
        values: _PROGRESS_TIME_RANGE.filter(progressTimeRange => {
          return progressTimeRange.value === this.eventProps.expectProgressTime
        })[0]?.title + this.$t('unit.mins'),
        value: _PROGRESS_TIME_RANGE.filter(progressTimeRange => {
          return progressTimeRange.value === this.eventProps.expectProgressTime
        })[0]?.value,
      }
    ];
    return {
      items: item
    }
  },
  methods: {
    getValue() {
      return {
        date: this.items[0].values,
        startTime: Array.isArray(this.items[1].values) ? this.items[1].value[0] : this.items[1].value,
        progressTime: Array.isArray(this.items[2].values) ? this.items[2].value[0] : this.items[2].value
      }
    }
  }
}
</script>